import { render } from "./InputSearchProcedure.vue?vue&type=template&id=ebb3ef02"
import script from "./InputSearchProcedure.vue?vue&type=script&lang=js"
export * from "./InputSearchProcedure.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__